import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Infrastructure() { 
  useEffect(() => {
    document.title = 'Infrastructure -  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Academics</li>
                <li>Infrastructure</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Infrastructure</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <p>Carmel Convent has a spacious, well planned building with well-ventilated classrooms surrounded by lawns and playgrounds. </p>
               <p>The Computer labs  equipped with the latest computers and multimedia technology. </p>
               <p>The Audio-Visual Room is equipped both for teaching the students and viewing the presentations made by them. The use of audio visual aids is well integrated with the school curriculum and this room is extensively used by the staff and students alike. </p>
               <p>The school has a School Library. The reference library which is fully computerized and houses over 2,000 books, is a treasure trove of information that continues to grow each year. Reading sessions are conducted regularly exposing students to good written and reading skills. </p>
               <p>Carmel has playgrounds, dance room, music room for the children. During the activity period these grounds and rooms are used for various activities like skating, taekwondo, dance, exercising etc. </p>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Infrastructure;
